import { isIndex as f } from "../_internal/isIndex.js";
import { toPath as y } from "../util/toPath.js";
function g(s, t, i) {
  var e = Array.isArray(t) ? t : typeof t == "string" ? y(t) : [t];
  var r = s;
  for (var n = 0; n < e.length - 1; n++) {
    var o = e[n],
      c = e[n + 1];
    r[o] == null && (r[o] = f(c) ? [] : {}), r = r[o];
  }
  var l = e[e.length - 1];
  return r[l] = i, s;
}
export { g as set };